import styled from "styled-components";

import { Modal } from "@similarweb/ui-components";

export const StyledActionModalFooter = styled(Modal.Footer)`
    padding-top: 16px;
`;
export const StyledActionModalContent = styled(Modal.Content)`
    padding: 16px 24px;
`;
